import { gtb, towne, fizz } from "./companies";
import { GtbCustomApp } from "./companies/gtb/types";
import { CustomApp } from "./types";

export const companies: [RegExp, CustomApp | GtbCustomApp][] = [
  [/^([^.]+.)?gtbevents.live$/, gtb],
  [/towne/, towne],
  [/fizz/, fizz],
];
